export default "__VITE_ASSET__2bf5a625__"